module.exports = __webpack_public_path__ + "img/menu-item-0.83e57700.svg";